import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Blog - Get All (Read)
export const GetAll = createAsyncThunk(
  "blogs/blog/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Blogs.Blog}?name=${filter?.name || ""}
        &description=${filter?.description || ""}&title=${filter?.title || ""}
        &popular_tag=${filter?.popular_tag || ""}&conclusion=${filter?.conclusion || ""}
        &image=${filter?.image || ""}
        &page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Blog - Get (Read)
export const GetSingle = createAsyncThunk(
  "blogs/blog/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Blogs.Blog}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Blog - Create (Add)
export const Create = createAsyncThunk(
  "blogs/blog/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Blogs.Blog, data);
      return res; // The new blog object
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Blog - Update
export const Update = createAsyncThunk(
  "blogs/blog/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Blogs.Blog}/${id}`, data);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Blog - Delete
export const Delete = createAsyncThunk(
  "blogs/blog/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Blogs.Blog}/${id}`);
      return id; // Return the id of the deleted blog
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Blog - Status
export const StatusBlog = createAsyncThunk(
  "blogs/blog/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Blogs.Blog}/${id}`);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "blog",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (blog) => blog.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (blog) => blog.id !== action.payload.id); // Remove the blog with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusBlog.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusBlog.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (blog) => blog.id !== action.payload.id); // Remove the blog with the deleted id
      })
      .addCase(StatusBlog.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
